import { buildInsightTypeLabels, INSIGHT_TYPE_CONFIG } from '../../../model/constants';
import type { InsightType } from '../../../model/types';

function normalize(type: string): InsightType | null {
  const normalized = type.toLowerCase().replace(/[\s/]+/g, '_');
  return normalized in INSIGHT_TYPE_CONFIG ? (normalized as InsightType) : null;
}

export function InsightTypeBadge({ type }: { type: string }) {
  const normalized = normalize(type);
  if (!normalized) return null;
  const { bg } = INSIGHT_TYPE_CONFIG[normalized];
  return (
    <span
      className={`inline-flex items-center justify-center px-2 py-1 rounded-full text-xs text-white whitespace-nowrap ${bg}`}
    >
      {buildInsightTypeLabels()[normalized]}
    </span>
  );
}
